'use client';

import { useEffect } from 'react';

export function HydrationReady() {
  useEffect(() => {
    document.body.setAttribute('data-hydrated', 'true');
  }, []);
  return null;
}
